<template>
  <div :class="['res_nav', { 'nav-hidden': isHidden }]">
    <v-app-bar class="nav-bar" dense>
      <v-row align="center" justify="space-between">
        <!-- Cart Icon -->
        <v-col cols="4" class="d-flex justify-center align-center">
          <v-btn icon variant="text" @click="openCart" aria-label="Cart">
            <v-badge
              :content="itemsCount"
              :model-value="itemsCount > 0"
              color="red"
            >
              <v-icon size="30">mdi-cart-outline</v-icon>
            </v-badge>
          </v-btn>
        </v-col>

        <!-- Logo -->
        <v-col cols="4" class="d-flex justify-center align-center">
          <img
            src="@/assets/logo.png"
            alt="Logo"
            @click="$router.push({ name: 'home' })"
            class="logo"
            style="cursor: pointer"
          />
        </v-col>

        <!-- Menu Icon -->
        <v-col cols="4" class="d-flex justify-center align-center">
          <v-app-bar-nav-icon @click="openMenu" class="large-nav-icon" />
        </v-col>
      </v-row>
    </v-app-bar>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useCartModule } from "@/stores/cart";

export default {
  inject: ["Emitter"],
  data() {
    return {
      isHidden: false, // Controls if the nav is hidden
      lastScrollPosition: 0, // Keeps track of the last scroll position
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll); // Add scroll listener
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll); // Remove listener
  },
  computed: {
    ...mapState(useCartModule, ["itemsCount"]),
  },
  methods: {
    handleScroll() {
      const currentScroll = window.scrollY;

      if (currentScroll > this.lastScrollPosition && currentScroll > 50) {
        // Scrolling down
        this.isHidden = true;
      } else if (currentScroll < this.lastScrollPosition) {
        // Scrolling up
        this.isHidden = false;
      }

      this.lastScrollPosition = currentScroll;
    },
    openMenu() {
      this.Emitter.emit("openMenu");
    },
    openCart() {
      this.Emitter.emit("openCart");
    },
    navigateToContactUs() {
      this.$router.push({ name: "contact_us" });
    },
  },
};
</script>

<style scoped>
/* The nav bar container */
.res_nav {
  position: fixed; /* Keep nav fixed to the top */
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  transition: transform 0.3s ease-in-out; /* Smooth transition */
}

/* When nav is hidden, slide it up */
.nav-hidden {
  transform: translateY(-100%);
}

.nav-bar {
  background-color: white;
  padding: 0 16px;
  height: 64px;
  display: flex;
  align-items: center;
}

.logo {
  height: 70px;
  max-width: 100px;
  object-fit: contain;
}

.large-nav-icon {
  width: 40px;
  height: 40px;
  padding: 8px;
}

@media (max-width: 600px) {
  .logo {
    height: 30px;
  }
}
</style>
